import Axios from "axios";

import { API_URL } from "../config";
import storage from "../utils/storage";
import { toast } from "react-toastify";

function authRequestInterceptor(config) {
  const token = storage.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.headers.Accept = "application/json";
  return config;
}

export const axios = Axios.create({
  baseURL: API_URL,
});

axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const status = error.response?.status;
    const message =
      error.response?.data?.message || error.message || "Something went wrong!";

    // Stale / invalid session — clear and let AuthLoader show login
    if (status === 401) {
      storage.clearToken();
    }

    // Avoid noisy toasts for expected unauthenticated probes
    const url = String(error.config?.url || "");
    const isSessionProbe = url.includes("/auth/adminme");
    if (!(status === 401 && isSessionProbe)) {
      toast.error(message);
    }

    return Promise.reject(error);
  }
);
